import React from "react";
import { createPortal } from "react-dom";
import { AppendBodyTargetContext } from "./append-body-target-context";

export const AppendBody = React.memo(function AppendBody(props: {
  id?: string;
  className?: string;
  children?: React.ReactNode;
}) {
  const targetDocument = React.useContext(AppendBodyTargetContext) ?? document;
  return createPortal(
    <div id={props.id} className={props.className}>
      {props.children}
    </div>,
    targetDocument.body
  );
});
